import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Button, Typography } from '@mui/material';
import HotelCard from './HotelCard';
import HotelLoader from './HotelLoader';
import useForaStore from '../../store/hotel/fora';
import useSearchStore from '../../store/hotel/search';
import useSearchHooks from '../../store/hotel/search-hooks';

export default function HotelListVip() {
  const { getForaMore } = useSearchHooks();
  const search = useSearchStore((state) => state);
  const { list, isLoading } = useForaStore((state) => ({
    list: state.list,
    isLoading: state.isLoading,
  }));
  if (isLoading && list.length === 0) {
    return <HotelLoader length={4} />;
  }

  if (list.length === 0) {
    return null;
  }

  if (list.length > 0 && list.length === 0) {
    return (
      <Container fluid bg="black">
        <Container className="p-4">
          <Row className="h-50 h3">We could not find any results for your search.</Row>
        </Container>
      </Container>
    );
  }

  console.log(list);

  return (
    <Container fluid bg="black">
      <Container className="p-4">
        <Typography variant="h4" sx={{ font: 'grifo_m_regular', marginBottom: '30px', fontSize: '2.125rem' }} gutterBottom>
          VIP Perks & Amenities
        </Typography>
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {list.map((hotel) => (
            <Col key={hotel.id}>
              <HotelCard hotel={hotel} queryParameter={search} vip />
            </Col>
          ))}
        </Row>
        {isLoading && list.length > 0 && <HotelLoader length={8} />}
        <Button
          sx={{
            borderRadius: '20px',
            color: 'white',
            marginTop: '25px',
            borderColor: 'white',
            paddingLeft: '30px',
            paddingRight: '30px',
          }}
          variant="outlined"
          onClick={() => getForaMore()}
        >
          Load More
        </Button>
      </Container>
    </Container>
  );
}
